export const GET_REPORT_PHOTO = 'GET_REPORT_PHOTO';
export const GET_TECHNICIAN_INFO = 'GET_TECHNICIAN_INFO';
export const GET_COUNT_ATTACHMENT = 'GET_COUNT_ATTACHMENT';
